module.exports = __webpack_public_path__ + "img/Gyrocopter.afa3e877.png";